import IProductVariantList from '../model/IProductVariantList';
import IVariantDetails from '../model/IVariantDetails';
import { ICarDetails } from '../../../../common/model/ICarDetails';
import IDeal from '../../common/model/IDeal';
import IOptionList from '../model/IOptionList';
import IAccessoriesCategory from '../model/accessories/IAccessoriesCategory';
import ICustomisedCar from '../../../../common/model/ICustomisedCar';
import { TSectionsKeys } from '../model/IStoreTypes';
import IExtendedAccessoryPack from '../model/accessories/IExtendedAccessoryPack';
import { IFinanceQuote } from '../../common/model/IFinanceQuote';
import { IPrice, IPrices } from '../../../../common/model/IPrice';
import ICarConfigOption from '../../../../common/model/ICarConfigOption';
import IVariantSpecifications from '../model/IVariantSpecifications';
import IPlainPartExchange from '../../common/model/IPlainPartExchange';
import IStockListResponse from '../../stock/model/IStockListResponse';
import IBaseValidate from '../../stock/model/validate/IBaseValidate';
import TransferModalType from '../../stock/enum/TransferModalType';

// @TODO: This should not be called with initial. This is the interface of the state
// not data for initial state.
export interface IInitialState {
  customiseInitialState: {
    selectedSection: TSectionsKeys | null;
    specificationsFeaturesModal: boolean;
    isSecondaryCurrencyDisplay: boolean;
    postcode: number | null;
    sections: {
      variant: {
        expanded: boolean;
      };
      colour: {
        expanded: boolean;
      };
      interior: {
        expanded: boolean;
      };
      options: {
        expanded: boolean;
      };
      accessories: {
        expanded: boolean;
      };
      service: {
        expanded: boolean;
      };
      summary: {
        expanded: boolean;
      };
      exterior: {
        expanded: boolean;
      };
    };
  };
  variantsListInitialState: {
    loading: boolean;
    error?: any;
    variantsList: IProductVariantList | null;
  };
  variantSpecificationsInitialState: {
    loading: boolean;
    error?: any;
    variantSpecifications: IVariantSpecifications | null;
    currentSpecificationsVariantId: string | null;
  };
  variantDetailsInitialState: {
    loading: boolean;
    error?: any;
    variantDetails: IVariantDetails | null;
    marketingCategory: string | null;
  };
  carConfigurationInitialState: {
    loading: boolean;
    error?: any;
    configuration: ICarDetails | null;
    customisedCar: ICustomisedCar | null;
  };
  optionsInitialState: {
    loading: boolean;
    error?: any;
    options: IOptionList | null;
    accessoriesCategories: IAccessoriesCategory[];
    accessoryPacks: IExtendedAccessoryPack[];
  };
  partExchangeInitialState: {
    loading: boolean;
    partExchange: IPlainPartExchange | null;
    partExchangeValuation: number;
  };
  currentDealInitialState: {
    loadingCount: number;
    loading: boolean;
    error?: any;
    currentDeal: IDeal | null;
    financeQuote: IFinanceQuote;
    secondaryFinanceQuote: IFinanceQuote | null;
    prices: {
      carPrices: IPrices;
      deposit: number;
      totalAmountPayable: IPrice;
      primaryTotalPrice: IPrice;
      secondaryTotalPrice: IPrice;
      primaryPrice: IPrice;
      secondaryPrice: IPrice;
      totalPrice: IPrice;
      isMultiCurrency: boolean;
      servicePlanPrice: number;
    };
    servicePlan: ICarConfigOption;
    accessories: ICarConfigOption[];
    accessoryPacks: ICarConfigOption[];
  };
  listInitial: {
    loading: boolean;
    stockList: IStockListResponse | null;
    transfer: {
      loading: boolean;
      modalOpen: boolean;
      modalType: TransferModalType | null;
      nextVehicleId: string | null;
      invalid: IBaseValidate | null;
      valid: IBaseValidate | null;
      image: string | null;
      nextVariantName: string | null;
    };
    filters: {
      exteriorColours: string[];
      interiors: string[];
      variantIds: string[];
    };
  };
}

export const initialState: IInitialState = {
  customiseInitialState: {
    specificationsFeaturesModal: false,
    isSecondaryCurrencyDisplay: false,
    selectedSection: 'variant',
    postcode: null,
    sections: {
      variant: {
        expanded: true,
      },
      colour: {
        expanded: true,
      },
      interior: {
        expanded: true,
      },
      options: {
        expanded: true,
      },
      accessories: {
        expanded: true,
      },
      service: {
        expanded: true,
      },
      summary: {
        expanded: true,
      },
      exterior: {
        expanded: true,
      },
    },
  },
  variantsListInitialState: {
    loading: false,
    variantsList: null,
  },
  variantDetailsInitialState: {
    loading: false,
    variantDetails: null,
    marketingCategory: null,
  },
  variantSpecificationsInitialState: {
    loading: false,
    variantSpecifications: null,
    currentSpecificationsVariantId: null,
  },
  carConfigurationInitialState: {
    loading: false,
    configuration: null,
    customisedCar: null,
  },
  optionsInitialState: {
    loading: false,
    options: null,
    accessoriesCategories: [],
    accessoryPacks: [],
  },
  partExchangeInitialState: {
    loading: true,
    partExchange: null,
    partExchangeValuation: null,
  },
  currentDealInitialState: {
    loadingCount: 0,
    loading: false,
    currentDeal: null,
    financeQuote: null,
    secondaryFinanceQuote: null,
    prices: {
      isMultiCurrency: false,
      carPrices: [],
      deposit: 0,
      totalAmountPayable: null,
      primaryTotalPrice: null,
      secondaryTotalPrice: null,
      primaryPrice: null,
      secondaryPrice: null,
      totalPrice: null,
      servicePlanPrice: 0,
    },
    servicePlan: null,
    accessories: [],
    accessoryPacks: [],
  },
  listInitial: {
    loading: false,
    transfer: {
      loading: false,
      modalType: null,
      modalOpen: false,
      nextVehicleId: null,
      invalid: null,
      valid: null,
      image: null,
      nextVariantName: null,
    },
    stockList: null,
    filters: {
      exteriorColours: [],
      interiors: [],
      variantIds: [],
    },
  },
};

export default initialState;
